<template>
    <div class="coll-box">
        <div class="coll-tit" :class="hide ? '':'border_b'">
          <span v-html="title"></span>
          <div class="coll-action" :class="isToggle ? 'mr':''">
            <slot name="action"></slot>
          </div>
          <i onselectstart="return false" @click="toggle" v-if="isToggle" class="iconfont" :class="hide ? 'el-icon-arrow-down': 'el-icon-arrow-up'"></i>
        </div>
        <div class="coll-msg" v-show="!hide">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
  .coll-box{
    .coll-tit{
      position: relative;
      font-size: 14px;
      padding: 9px 0;
      height: 55px;
      box-sizing: border-box;
      &.border_b{
        border-bottom: 1px solid #EAEAEA;
      }
      .coll-action{
        position: absolute;
        right: 0;
        top: 12px;
        &.mr{
          right: 54px;
        }
        .btn-blue{
          min-width: 120px;
          min-height: 30px;
          display: inline-block;
          text-align: center;
          line-height: 30px;
          box-sizing: border-box;
          padding: 0 20px;
          border-radius: 19px;
          &+.btn-blue{
            margin-left: 20px;
          }
        }
        /*.limit-btn{*/
        /*  display: inline-block;*/
        /*  &+.btn-blue{*/
        /*    margin-left: 20px;*/
        /*  }*/
        /*}*/
      }
      >span{
        display: inline-block;
        margin-top:9px;
        padding-left: 8px;
        line-height: 18px;
        height: 18px;
        position: relative;
        color: #333333;
        i{
          font-style: normal;
          color: #E44245;
          display: inline-block;
          margin-left: 20px;
        }
        &:before{
          content: '';
          position: absolute;
          left: 0;
          top: 2px;
          width: 2px;
          height: 14px;
          background-color: #7996f5;
        }
      }

      >i.iconfont{
        position: absolute;
        top: 50%;
        right: 18px;
        font-style: normal;
        font-size: 18px;
        font-weight: bold;
        color: #7996F5;
        transform: translateY(-50%);
        line-height: 36px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    .coll-msg{

    }
  }

</style>

<script>
  export default {
    name: 'ZCollapse',
    props: {
      title: String,  // 标题
      isToggle:{
        type:Boolean,
        default:false
      },  // 是否有伸缩按钮
      isHide:{
        type:Boolean,
        default:false
      }, // 是否隐藏 默认 否
    },

    data() {
      return {
        hide: this.isHide
      }
    },
    watch:{
      isHide(val){
        let _this = this;
        _this.hide = val;
      }
    },
    methods: {
      toggle () {
          let _this = this;
          if(_this.isToggle){
            _this.hide = !_this.hide;
          }
       },
    },
    mounted() {
      // console.log(this.hide);
    }
  };
</script>


